<template>
    <div v-if="ready">
        <img src="@/assets/img/datitop.png" width="100%" alt="">
        <div class="timu">
            <div class="question_title">一、单选题【共{{count}}题，共{{pointCount}}分】</div>
            <div class="question_desin">
                {{timu.strcount}}.{{timu.name}}
            </div>
            <RadioGroup v-model="answer" style="margin-top: 0.5rem;font-size: 5rem" @change="radiochange">
                <CellGroup>
                    <Cell size="large">
                        <Radio :checked-color="submitAanswer=='A' && timu.daan !== 'A'?'#D6473B':''" :class="submitAanswer=='A'?'active':''" name="A"><span class="sp">A.{{timu.Axuan}}</span></Radio>
                    </Cell>
                    <Cell size="">
                        <Radio :checked-color="submitAanswer=='B' && timu.daan !== 'B'?'#D6473B':''" :class="submitAanswer=='B'?'active':''" name="B"><span class="sp">B.{{timu.Bxuan}}</span></Radio>
                    </Cell>
                    <Cell size="">
                        <Radio :checked-color="submitAanswer=='C' && timu.daan !== 'C'?'#D6473B':''" :class="submitAanswer=='C'?'active':''" name="C"><span class="sp">C.{{timu.Cxuan}}</span></Radio>
                    </Cell>
                    <Cell size="large">
                        <Radio :checked-color="submitAanswer=='D' && timu.daan !== 'D'?'#D6473B':''" :class="submitAanswer=='D'?'active':''" name="D"><span class="sp">D.{{timu.Dxuan}}</span></Radio>
                    </Cell>
                </CellGroup>
            </RadioGroup>
        </div>
        <div style="margin: 0 0.3rem;margin-top: 0.1rem;">
            <Button v-if="index == count -1"  color="#D7463A" round size="large" @click="next">确定</Button>
            <Button v-else color="#D7463A" round size="large" @click="next">下一题</Button>
        </div>

        <Overlay  :show="success_show" @click.stop>
            <div class="innerbox">
                <img width="50%" src="@/assets/img/top.png" alt="" style="margin-left:25%;" />
                <div class="again">
                    恭喜获得{{getpoint}}积分
                </div>
                <div class="jifen" @click="$router.replace({path:'/'})">返回首页</div>
                <!-- <img class="close" src="@/assets/img/close.png" alt=""  @click="show = false" /> -->
            </div>
        </Overlay>
        <Overlay  :show="err_show" @click.stop>
            <div class="innerbox">
                <img width="50%" src="@/assets/img/file.png" alt="" style="margin-left:25%;" />
                <div class="again" @click="$router.replace({path:'/answer/challenge_answer'})">
                   再来一次
                </div>
                <div class="jifen" @click="$router.replace({path:'/'})">返回首页</div>
                <!-- <img class="close" src="@/assets/img/close.png" alt=""  @click="show = false" /> -->
            </div>
        </Overlay>
        <CountDown
            :time='start_time'
            format="mm:ss"
            ref="countDown"
            @finish='finish'
            @change="tmcg"
        >
            <template #default="timeData">
                <div class="footer">
                    本次挑战剩余时间：{{timeData.minutes}}分{{timeData.seconds}}秒
                </div>
            </template>
        </CountDown>
    </div>
</template>

<script>
import {RadioGroup, Radio ,CellGroup,Cell,Button,Overlay,CountDown } from 'vant';
import { putchall,challAnserer} from "@api/answer";
export default {
    components:{RadioGroup, Radio,CellGroup,Cell,Button,Overlay,CountDown },
    data(){
        return {
            success_show: false,
            err_show: false,
            ready: false,
            answer:'',
            count:'',//题目数量
            list:[],//题目列表
            submitAanswer:'',
            getpoint: 0,
            index: 0,
            pointCount: '',
            answerList:[],
            start_time: 0,
            surplus_time:0,//剩余多少秒
        }
    },
    created(){
        this.getdata();
    },
    computed:{
        timu(){
            return this.list[this.index]
        }
    },
    methods:{
        getdata(){
            let res = JSON.parse(sessionStorage.getItem('answerData'));
            console.log(res)
            this.list = res.list;
            this.count = res.count;
            this.pointCount = res.pointCount;
            this.ready = true;
            this.start_time  = res.shijian* 60 * 1000;
        },
        radiochange(e){
            // this.answer = "A"
            if(this.submitAanswer){
                this.answer = this.submitAanswer;
            }
        },
        next(){
            if(this.answer == ''){
                this.$dialog.error('请先选择答案');
            }else{
                let obj = {
                    id: this.list[this.index].id,
                    daan: this.answer
                };
                this.answerList.push(obj);
                if(this.answer !== this.list[this.index].daan){
                    this.err_show = true;
                    this.$refs.countDown.pause();
                    this.dati();
                }else{
                    if(this.index == this.list.length -1){
                        this.success_show = true;
                        this.$refs.countDown.pause();
                        this.dati();
                    }else{
                        this.answer = '';
                        this.index = this.index +1;
                    }
                }
            }
           
        },
        dati(){    
            putchall({
                list: this.answerList,
                miao: this.start_time/1000 - this.surplus_time
            }).then(res=>{
                this.getpoint = res.data.point
            })
        },
        tmcg(e){
            this.surplus_time = e.minutes *60 + e.seconds*1;
        },
        pass(){
            this.$refs.countDown.pause();
        },
        finish(){
            this.dati();
            this.err_show = true;
        }
    }
}
</script>

<style scoped>
    .timu{
        padding: 0.3rem;
    }
    .timu .question_title{
        font-size: 0.32rem;
        line-height: 0.6rem;
    }
    .timu .question_desin{
        margin-top: 0.3rem;
        font-size: 0.3rem;
        line-height: 0.46rem;
    }
    .van-radio{
        font-size: 0.3rem;
        padding: 0.15rem;
    }
    .van-nav-bar .van-icon{
        color: #333333;
        font-size: 0.4rem;
    }
    .active .sp{
        color: #D6473B;
    }

    .innerbox{
        width: 80%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate( -50%,-50%);
    }
    .jifen{
        margin-left: 10%;
        width: 80%;
        background-image: url('~@/assets/img/bot.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        text-align: center;
        line-height: .8rem;
        font-size: 0.4rem;
        font-weight: normal;
        font-size: 0.28rem;
        margin-top: 0.4rem;
        color: #333333;
    }
    .again{
        margin-left: 10%;
        width: 80%;
        background-image: url('~@/assets/img/again.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        text-align: center;
        line-height: .8rem;
        font-size: 0.5rem;
        font-weight: normal;
        font-size: 0.28rem;
        color: white;
        margin-top: 0.4rem;
    }
    .close{
        position: absolute;
        top: -0.8rem;
        right: 0;
        height: 0.8rem;
    }
    .bottom{
        height: 1rem;
        line-height: 1rem;
        position: fixed;
        width: 100%;
        text-align: center;
        bottom: 0;
        font-size: 0.4rem;
        color: #ffffff;
        background-color: rgba(0,0,0,0.9);
        z-index: 99;
    }
    .footer{
        position: fixed;
        width: 100%;
        line-height: 1rem;
        bottom: 0;
        color: #66635E;
        background-color: #FFEDD1;
        text-align: center;
        font-size: 0.32rem;
    }
</style>